import axios from "axios";
import { store } from "../store";
import config from "../config";
import authHeader from "./auth-header";
import {
  buildAppointmentCampaignListRequest,
  buildCampaignOptionRequest,
  buildCampaignViewRequest,
} from "./contentContract";

const API_URL = config.API_URL;

const create = (values) => {
  const auth = store.getState().auth;
  const auth_key = values?.auth_key || auth?.user?.auth_key || "";
  const formData = new FormData();
  for (let value in values) {
    formData.append(value, values[value]);
  }
  const action = "afterlogin/appointmentcampaign/store";
  formData.append("auth_key", auth_key);
  formData.append("action", action);
  return axios.post(API_URL + action, formData, { headers: authHeader({ contentType: "multipart/form-data" }) });
};

const update = (values) => {
  const auth = store.getState?.()?.auth || {};
  const auth_key = values?.auth_key || auth?.user?.auth_key || "";
  const clickEvent = values && values.clickEvent;
  if (clickEvent && clickEvent === "statusupdate") {
    const statusData = {
      is_active: values.is_active ? 1 : 0,
      auth_key,
      action: `afterlogin/appointmentcampaign/isactive/${values.id}`,
    };
    const statusFormData = new FormData();
    Object.entries(statusData).forEach(([key, value]) => statusFormData.append(key, value));
    return axios.post(API_URL + statusData.action, statusFormData, { headers: authHeader({ contentType: "multipart/form-data" }) });
  }
  const formData = new FormData();
  for (let value in values) {
    formData.append(value, values[value] ? values[value] : "");
  }
  const action = "afterlogin/appointmentcampaign/update/" + values.id;
  formData.append("auth_key", auth_key);
  formData.append("action", action);
  return axios.post(API_URL + action, formData, { headers: authHeader({ contentType: "multipart/form-data" }) });
};

const view = (values) => {
  const campaignId = Number(values && values.id);
  const request = Number.isInteger(campaignId) && campaignId > 0
    ? buildCampaignViewRequest("afterlogin/appointmentcampaign/view", values)
    : buildAppointmentCampaignListRequest(values);
  return axios.post(API_URL + request.url, request.body, { headers: authHeader() });
};

const deleted = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const action = `afterlogin/appointmentcampaign/delete/${values.id}`;
  const data = {
    auth_key: auth_key,
    action: action,
  };
  return axios.post(API_URL + action, data, { headers: authHeader() });
};

const addonservices = (values) => {
  const request = buildCampaignOptionRequest("afterlogin/appointmentcampaign/addonservices", values);
  return axios.post(API_URL + request.url, request.body, { headers: authHeader() });
};


const addonproducts = (values) => {
  const request = buildCampaignOptionRequest("afterlogin/appointmentcampaign/addonproducts", values);
  return axios.post(API_URL + request.url, request.body, { headers: authHeader() });
};

const sendemail = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const action = 'afterlogin/appointmentcampaign/sendemail';
  const formData = new FormData();
  for (let value in values) {
    formData.append(value, values[value] ? values[value] : "");
  }
  formData.append("auth_key", auth_key);
  formData.append("action", action);
  return axios.post(API_URL + action, formData, { headers: authHeader({ contentType: "multipart/form-data" }) });
};

const AppointmentCampaignApiController = {
  create,
  update,
  view,
  deleted,
  addonservices,
  addonproducts,
  sendemail,
};
export default AppointmentCampaignApiController;
